import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'
import { SaveDriverSettingsInput } from './SaveDriverSettingsInput'

@InputType()
export class SaveDriverArgs extends ActionArgs {
  @Field(() => ID, { nullable: true })
  _id?: string

  @Field(() => String, { nullable: true })
  code?: string

  @Field(() => String, { nullable: true })
  name?: string

  @Field(() => String, { nullable: true })
  status?: string

  @Field(() => String, { nullable: true })
  remarks?: string

  @Field(() => String, { nullable: true })
  samplerLicenseNo?: string

  @Field(() => Date, { nullable: true })
  licenseNoExpirationDate?: Date

  @Field(() => [String], { nullable: true })
  tags?: string[]

  @Field(() => SaveDriverSettingsInput, { nullable: true })
  settings?: SaveDriverSettingsInput
}
